var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDisplaySmallCustomCreditCardPrimary = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h25v25H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#1B7690",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.326 8.773v-.99c0-1.128-.964-2.053-2.17-2.053H4.716c-1.192 0-2.17.913-2.17 2.054v.989c0 .1.08.177.187.177h19.392c.107 0 .201-.076.201-.177zM2.546 10.514v6.44c0 1.162.964 2.116 2.168 2.116h15.444c1.191 0 2.168-.94 2.168-2.116v-6.44a.18.18 0 0 0-.187-.183H2.733c-.107-.013-.187.079-.187.183zm4.938 4.938c0 .326-.28.6-.615.6h-.616a.615.615 0 0 1-.616-.6v-.601c0-.327.282-.601.616-.601h.616c.334 0 .615.274.615.6v.602z"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDisplaySmallCustomCreditCardPrimary);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/display-small-custom-credit-card-primary.05b14d2a0f4a4249a1055e486b11e3cc.svg";